import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import MarketingBannerBlockData from '../../../Models/Content/MarketingBannerBlockData';
import {MarketingBannerBlockMain} from './MarketingBannerBlockMain';

export default class MarketingBannerBlock extends EpiComponent<MarketingBannerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MarketingBannerBlockMain context={this.getContext()} contentData={this.props.data} />;
  }
}
